export default __webpack_public_path__ + "static/media/fotoHomem.6c823eab.png";